module.exports = __webpack_public_path__ + "static/img/10002B_X_02_20170621_LC.d5dce8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/10002B_X_02_20170621_LC.png
// module id = Aoty
// module chunks = 0